import React, { useRef, useState } from "react";
import Slider from "react-slick";
import slider from "../../data/SliderHomeThree.json";
import { useNavigate } from "react-router-dom";

// Import images directly so Webpack bundles them securely
import bg1 from "../../assets/img/bg/1.jpg";
import bg2 from "../../assets/img/bg/2.jpg";
import bg3 from "../../assets/img/bg/3.jpg";

const getImageById = (id) => {
  switch (id) {
    case 1: return bg2;
    case 2: return bg1;
    case 3: return bg3;
    default: return bg1;
  }
};

const SliderHomeThree = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    fade: true,
    arrows: false,
    afterChange: (current) => setActiveIndex(current),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows: false,
        },
      },
    ],
  };
  const sliderRef = useRef(null);
  const navigate = useNavigate()

  const handleSliderAreaClick = () => {
    // First, check if the user was dragging/swiping, not clicking. If so, do nothing.
    if (sliderRef.current?.innerSlider?.state?.dragging) {
      return;
    }

    // Get the redirect path from our original data array, using the reliable activeIndex from our state.
    const redirectPath = slider.SliderHomeThree[activeIndex]?.redirect;

    if (redirectPath) {
      navigate(redirectPath);
    }
  };

  return (
    <>
      {/* <!-- slider-3 --> */}
      <div className="slider-home-three">
        <div className="tp-slider-area-3 p-relative">
          <Slider ref={sliderRef} {...settings} className="tp-silder-acive-3">
            {slider?.SliderHomeThree.map((item) => (
              <div key={item.id}>
                <div
                  onClick={handleSliderAreaClick} // Pass the handler directly
                  data-redirect={item.redirect}
                  className="tp-slider-item-3 tp-slider-height-3 silder-overlay"
                  style={{ backgroundImage: `url(${getImageById(item.id)})`, cursor: "pointer" }}
                >
                  <div className="tp-slider-text white-box">
                    <span className="text-white">{item?.description}</span>
                    <h3 className="tp-slider-title tp-sl-lg-text text-white mt-40 mb-55">
                      {item.title1} <br /> {item.title2}
                    </h3>

                    <a href="/contact" className="tp-slider-btn" onClick={(e) => e.stopPropagation()}>
                      <span>
                        <svg
                          width="53"
                          height="8"
                          viewBox="0 0 53 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M52.3536 4.35356C52.5488 4.15829 52.5488 3.84171 52.3536 3.64645L49.1716 0.464469C48.9763 0.269207 48.6597 0.269207 48.4645 0.464469C48.2692 0.659731 48.2692 0.976314 48.4645 1.17158L51.2929 4L48.4645 6.82843C48.2692 7.02369 48.2692 7.34027 48.4645 7.53554C48.6597 7.7308 48.9763 7.7308 49.1716 7.53554L52.3536 4.35356ZM-3.11023e-08 4.5L52 4.5L52 3.5L3.11023e-08 3.5L-3.11023e-08 4.5Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                        <svg
                          width="53"
                          height="8"
                          viewBox="0 0 53 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M52.3536 4.35356C52.5488 4.15829 52.5488 3.84171 52.3536 3.64645L49.1716 0.464469C48.9763 0.269207 48.6597 0.269207 48.4645 0.464469C48.2692 0.659731 48.2692 0.976314 48.4645 1.17158L51.2929 4L48.4645 6.82843C48.2692 7.02369 48.2692 7.34027 48.4645 7.53554C48.6597 7.7308 48.9763 7.7308 49.1716 7.53554L52.3536 4.35356ZM-3.11023e-08 4.5L52 4.5L52 3.5L3.11023e-08 3.5L-3.11023e-08 4.5Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </span>
                      Get in touch
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="slider-arrow-3 d-flex justify-content-between align-items-center">
            <button
              onClick={(e) => {
                e.stopPropagation(); // Stop the main click handler
                sliderRef.current?.slickPrev();
              }}
              type="button"
              className="slick-prev slick-arrow"
            >
              <span>
                <i className="fal fa-angle-left"></i>
              </span>
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation(); // Stop the main click handler
                sliderRef.current?.slickNext();
              }}
              type="button"
              className="slick-next slick-arrow"
            >
              <span>
                <i className="fal fa-angle-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      {/* <!-- slider -3 --> */}
    </>
  );
};

export default SliderHomeThree;
